export default "__VITE_ASSET__Bzvmr0xH__"